import React from "react";
import "./Member.css";
import data from "../Team Members/members.json";
function Member(props) {
  const selectedId = props.id;
  const path = "/Assets/Members/";
  return (
    <div>
      <div>
        {data
          .filter((item) => item.id === selectedId)
          .map((item) => (
            <div key={item.id}>
              <div className="card">
                <img
                  src={path + item.id + ".jpg"}
                  className="card-img-top"
                  alt={process.env.PUBLIC_URL}
                />
                <div className="card-body">
                  <h5 className="card-title">{item.name}</h5>
                  <p className="card-text">{item.position}</p>
                </div>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
}
export default Member;
